import moment, { RelativeTimeKey } from 'moment';

import { DateFormatConfig } from './config/formatConfig';
import type { DateInput } from './types';

export const formattedDate = (timestamp: DateInput): string =>
  moment(timestamp).format(DateFormatConfig.GENERAL_DATE_FORMAT);

export const formattedCompletionTimestamp = (timestamp: DateInput): string =>
  moment(timestamp).format(
    `${DateFormatConfig.GENERAL_DATE_FORMAT}, ${DateFormatConfig.TIME_FORMAT}`
  );

export const formattedCompletionTimestampFull = (timestamp: DateInput): string =>
  moment(timestamp).format(
    `${DateFormatConfig.FULL_MONTH_DAY_YEAR}, ${DateFormatConfig.TIME_FORMAT}`
  );

export const formattedEventHeader = (timestamp: DateInput): string =>
  moment(timestamp).format(
    `${DateFormatConfig.GENERAL_DATE_FORMAT}, ${DateFormatConfig.TIME_FORMAT}`
  );

export const formattedDateHeader = (timestamp: DateInput): string =>
  moment(timestamp).format(DateFormatConfig.DATE_HEADER);

export const durationTranslate = (num: number, key: RelativeTimeKey): string => {
  const localeDate: moment.Locale = moment.localeData();
  return localeDate.postformat(localeDate.relativeTime(num, true, key, false));
};

export const getNumericDateFormat = (separator: string = '/'): string =>
  DateFormatConfig.NUMERIC_DATE.replace(/\//g, separator);

export const timeFromNow = (timestamp: DateInput): string => moment(timestamp).fromNow();

export const formatToRFCDate = (timestamp: DateInput): string => new Date(timestamp).toISOString();

const formatMinutesAndSeconds = (timestamp: number): string => {
  const seconds = timestamp % 60;
  const minutes = Math.floor(timestamp / 60);
  let result = minutes + 'm';
  if (seconds > 0) result += ' ' + seconds + 's';
  return result;
};

const formatHoursMinutesSeconds = (timestamp: number): string => {
  const seconds = timestamp % 60;
  const minutes = Math.floor((timestamp / 60) % 60);
  const hours = Math.floor(timestamp / 3600);

  let result = hours + 'h';
  if (minutes > 0) result += ' ' + minutes + 'm';
  if (seconds > 0) result += ' ' + seconds + 's';
  return result;
};

export const timeDurationFormatter = (timestamp: number): string => {
  if (!Number(timestamp)) return '';
  if (timestamp <= 0) return '';
  if (timestamp < 60) return timestamp + 's';
  if (timestamp < 3600) return formatMinutesAndSeconds(timestamp);
  return formatHoursMinutesSeconds(timestamp);
};

export const getYear = (): number => new Date().getFullYear();

export { moment };
